"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyProfileMainContent = void 0;
const CompanyProfileMainContent_1 = require("./CompanyProfileMainContent");
Object.defineProperty(exports, "CompanyProfileMainContent", { enumerable: true, get: function () { return CompanyProfileMainContent_1.CompanyProfileMainContent; } });
